import axios from "axios";
import { takeLatest, put } from "redux-saga/effects";

import { API_BASE_URI } from "../ApiCall";
import { SupplyFixContractActionTypes } from "./SupplyFixContract.type";

export function* fetchAllSupplyFixContracts(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/supply-fix-contract?supply_fix_id=${action.payload?.supply_fix_id}&date=${action.payload?.date}`
    );
    yield put({
      type: SupplyFixContractActionTypes.FETCH_ALL_SUPPLY_FIX_CONTRACT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: SupplyFixContractActionTypes.FETCH_ALL_SUPPLY_FIX_CONTRACT_FAILURE,
      payload: error,
    });
  }
}

export function* fetchOneSupplyFixContracts(action: any): any {
  try {
    const response = yield axios.get(
      `${API_BASE_URI}/supply-fix-contract/${action.payload}`
    );
    yield put({
      type: SupplyFixContractActionTypes.FETCH_ONE_SUPPLY_FIX_CONTRACT_SUCCESS,
      payload: response.data,
    });
  } catch (error) {
    yield put({
      type: SupplyFixContractActionTypes.FETCH_ONE_SUPPLY_FIX_CONTRACT_FAILURE,
      payload: error,
    });
  }
}

export function* watcherFetchAllSupplyFixContracts() {
  yield takeLatest(
    SupplyFixContractActionTypes.FETCH_ALL_SUPPLY_FIX_CONTRACT,
    fetchAllSupplyFixContracts
  );
}

export function* watcherFetchOneSupplyFixContracts() {
  yield takeLatest(
    SupplyFixContractActionTypes.FETCH_ONE_SUPPLY_FIX_CONTRACT,
    fetchOneSupplyFixContracts
  );
}
